import { render, staticRenderFns } from "./SelectedTopicEdit.vue?vue&type=template&id=714d0869&scoped=true&"
import script from "./SelectedTopicEdit.vue?vue&type=script&lang=js&"
export * from "./SelectedTopicEdit.vue?vue&type=script&lang=js&"
import style0 from "./SelectedTopicEdit.vue?vue&type=style&index=0&id=714d0869&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714d0869",
  null
  
)

export default component.exports